import { useEffect, useMemo, useState } from 'react';
import clsx from 'clsx';
import { ReactComponent as Arrow } from '../../assets/arrow.svg';
import style from './style.module.scss';

const weekDays = [
    'Lundi',
    'Mardi',
    'Mercredi',
    'Jeudi',
    'Vendredi',
    'Samedi',
    'Dimanche',
];

export const PracticeTimetableTile = ({ link, practice, timetable }) => {
    const [current, setCurrent] = useState();

    const filteredWeekDays = useMemo(
        () =>
            weekDays.filter((day) =>
                timetable ? timetable.find((item) => item.timetable_day === day) : false,
            ),
        [timetable],
    );

    useEffect(() => {
        setCurrent(filteredWeekDays[0]);
    }, [filteredWeekDays]);

    return (
        <div className={style.block}>
            <div className={clsx(style.tile, !timetable && style.withoutTimetable)}>
                {practice?.thumbnail && (
                    <div className={style.thumbnail}>
                        {<img src={practice.thumbnail} alt={practice.post_title} />}
                        <div className={style.logo}>
                            <img
                                src={practice.acf.logo.url}
                                alt={practice.acf.logo.url || practice.post_title}
                            />
                        </div>
                    </div>
                )}

                <div className={style.content}>
                    <div className={style.timetable}>
                        <div className={style.title}>{practice.post_title}</div>
                        <a
                            className={clsx(style.title, style.discover)}
                            href={practice.url}
                        >
                            Découvrir la pratique
                            <Arrow />
                        </a>

                        <div className={style.slots}>
                            <div className={style.daysSelector}>
                                {filteredWeekDays && filteredWeekDays.length > 0 && (
                                    <>
                                        <p> Créneaux </p>
                                        <hr />
                                        <menu className={style.days}>
                                            {filteredWeekDays.map((day) => {
                                                return (
                                                    <li
                                                        className={clsx(
                                                            style.day,
                                                            day === current &&
                                                                style.current,
                                                        )}
                                                        key={day}
                                                    >
                                                        <button
                                                            className={style.day_btn}
                                                            onClick={() =>
                                                                setCurrent(day)
                                                            }
                                                        >
                                                            {day.slice(0, 3) + '.'}
                                                        </button>
                                                    </li>
                                                );
                                            })}
                                        </menu>
                                    </>
                                )}
                            </div>

                            {filteredWeekDays.length > 0 && (
                                <ul className={style.list}>
                                    {timetable &&
                                        timetable.map((item, index) => {
                                            // i kept this security but should never happend
                                            if (item.timetable_day !== current) {
                                                return null;
                                            }

                                            return (
                                                <li key={index}>
                                                    <span className={style.training_name}>
                                                        {' '}
                                                        {item.training_title}{' '}
                                                    </span>
                                                    <div className={style.infos}>
                                                        <span>
                                                            De&nbsp;
                                                            <b>
                                                                {' '}
                                                                {item.time_start} à&nbsp;
                                                                {item.time_stop}
                                                            </b>
                                                        </span>
                                                        <span
                                                            className={
                                                                style[
                                                                    item.availability
                                                                        .value
                                                                ]
                                                            }
                                                        >
                                                            {item.availability.label}
                                                        </span>
                                                    </div>
                                                </li>
                                            );
                                        })}
                                </ul>
                            )}
                        </div>
                    </div>
                </div>

                {timetable && link && (
                    <a
                        href={link}
                        target={'_blank'}
                        rel={'noreferrer'}
                        className={clsx(style.title, style.button)}
                    >
                        Je m'inscris
                        <Arrow />
                    </a>
                )}
            </div>
        </div>
    );
};

export default PracticeTimetableTile;
